import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import { orderBy } from 'lodash-es';
// import Button from 'sushiweb/Button';
import Spinner from 'sushiweb/Spinner/Spinner';
import red from 'sushiweb/tokens/color/red';
import Plus from 'sushiweb/Icons/all/Plus';
import Search from 'sushiweb/Icons/all/Search';
import Button from 'sushiweb/Button';
import H5 from 'sushiweb/Typography/Heading/H5';
import Breadcrumb from 'sushiweb/Breadcrumb/Breadcrumb';
import Tooltip from 'sushiweb/Tooltip/Tooltip';
import Download from 'sushiweb/Icons/all/Download';

import {
  BreadCrumbWrapper,
  DashboardWrapper,
  SearchContainerV2,
  SearchInput,
  SpinnerHolder,
  StatusFilterAndExportCSVContainer,
  TabHeadWrapper,
  TabWrapper,
  TableContainer,
} from '../common/styles';
import DataTables from '../common/components/DataTables';
import {
  limitProgramsHeadColumn,
  fullFlexProgramHeadColumn,
  programHeadColumn,
} from '../common/components/DataTables/components/headColumns';
// import Error from '../common/components/DataTables/components/Error';
import {
  exportCSV,
  getCurrentDate,
  getCycleAmountForCSV,
  getEmployeesCountFromGroups,
  includesOption,
  indexOfOption,
  searchWithName,
} from '../../helpers';
import ErrorPage from '../common/components/ErrorPage';
import {
  PROGRAMS,
  REFRESH_LABEL,
  applicableFlowTypes,
  currentFlowTypeEnum,
  programStatusEnum,
  statusLabels,
} from '../common/components/constants';
import { MEAL_PLAN } from './CreateProgramModal/ProgramForms/common/Components/constants';
import CreateProgramModal from './CreateProgramModal';
import { DASHBOARD_ROUTE, HOME_ROUTE, CREATE_PLAN_ROUTE } from '../../constants/routes';
import EmptyStateV2 from '../common/components/EmptyStateV2/EmptyStateV2';
import { emptyProgramStateTitle } from '../../constants';
import StatusFilter from '../common/components/StatusFilter';
import Banner from '../common/components/Banner';
import AnnouncementBanner from '../common/components/AnnouncementBanner';
import { frequencyTypes } from './constants';
import ZTrackingClient from '../../jumbo/ZTrackingClient';
import { IsFullFlexProgramCreationEnabled } from '../../helpers/featureSupport';
// import { CREATE_PROGRAM } from '../../constants/routes';

const WalletPrograms = ({
  currentFlow,
  selectedWorkspace,
  companyData,
  fetchingPrograms,
  fetchedPrograms,
  programCreated,
  programsData,
  getAllGroups,
  getAllPrograms,
  getAllQuestions,
  viewOnlyMode,
}) => {
  const navigate = useNavigate();
  const { programs = [] } = programsData;
  const keyFields = ['name'];
  const isFullFlexEnabled = IsFullFlexProgramCreationEnabled(companyData);

  const [loading, setLoading] = useState(true);
  const [currentData, setCurrentData] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, onInputChange] = useState('');
  const [typingTimeout, setTypingTimeout] = useState(0);
  const [isEmptyPrograms, setisEmptyPrograms] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [canModalClose, setCanModalClose] = useState(true);
  const [currentFilters, setCurrentFilters] = useState([]);
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [disabledSearch, setDisabledSearch] = useState(false);
  const [filterStatusOptions, setFilterStatusOptions] = useState([
    // {
    //   value: [0],
    //   label: 'DRAFTED',
    // },
    {
      value: [1],
      label: 'PLAN_ACTIVE',
      disabled: true,
    },
    // {
    //   value: [2],
    //   label: 'PAUSED',
    // },
    // {
    //   value: [3],
    //   label: 'DELETED',
    // },
    {
      value: [4],
      label: 'COMPLETED_ENDED',
      disabled: true,
    },
    {
      value: [5],
      label: 'NOT_STARTED',
      disabled: true,
    },
  ]);
  const filterFunc = val => {
    let flag = false;
    currentFilters.forEach(filter => {
      for (let i = 0; i < filter.value.length; i += 1)
        if (val.program_status === filter.value[i]) flag = true;
    });
    return flag;
  };
  const statusFilter = val => {
    if (val.program_status !== 0 && val.program_status !== 3) {
      return true;
    }
    return false;
  };

  const enableCurrentFilters = availableStatuses => {
    for (let i = 0; i < filterStatusOptions.length; i += 1) {
      for (let j = 0; j < filterStatusOptions[i].value.length; j += 1) {
        if (availableStatuses.includes(filterStatusOptions[i].value[j])) {
          filterStatusOptions[i].disabled = false;
          break;
        } else filterStatusOptions[i].disabled = true;
      }
    }
    setFilterStatusOptions(filterStatusOptions);
  };

  const modalClose = {
    enable: () => setCanModalClose(true),
    disable: () => setCanModalClose(false),
  };
  const closeModal = override => {
    if (canModalClose || override) {
      setShowModal(false);
      getAllPrograms({
        workspaceId: selectedWorkspace.workspace_id,
        flowType: currentFlow,
      });
    }
  };

  useEffect(() => {
    if (selectedWorkspace && selectedWorkspace.workspace_id)
      getAllPrograms({
        workspaceId: selectedWorkspace.workspace_id,
        flowType: currentFlow,
      });
  }, [selectedWorkspace, currentFlow]);

  useEffect(() => {
    ZTrackingClient.recordImpression({
      ui_source: 'MEAL_PLANS',
      component: 'SIDE_NAV_BAR',
    });
  }, []);

  useEffect(() => {
    if (selectedWorkspace && selectedWorkspace.workspace_id)
      getAllGroups({
        workspaceId: selectedWorkspace.workspace_id,
        flowType: currentFlow,
      });
  }, [selectedWorkspace, currentFlow]);

  useEffect(() => {
    getAllQuestions();
  }, [currentFlow]);

  useEffect(() => {
    if (!fetchingPrograms) {
      if (programs) {
        programs.sort(
          (a, b) => new Date(b.start_date) - new Date(a.start_date),
        );
        const filteredPrograms = programs.filter(statusFilter);
        if (filteredPrograms.length === 0) {
          setDisabledSearch(true);
        }
        setSearchResults(filteredPrograms);
        setCurrentData(filteredPrograms.slice(0, 10));
      }
      setisEmptyPrograms(!programs || programs.length === 0);
      setLoading(false);
    }
  }, [fetchingPrograms]);

  useEffect(() => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const timeout = setTimeout(() => {
      if (!fetchingPrograms) {
        const arr = searchWithName(programs, search, keyFields);
        const draftedFilterArr = arr.filter(statusFilter);
        const availableStatuses = [];
        draftedFilterArr.forEach(data => {
          if (!availableStatuses.includes(data.program_status)) {
            availableStatuses.push(data.program_status);
          }
        });
        enableCurrentFilters(availableStatuses);
        if (currentFilters.length !== 0) {
          const filteredSearchArr = draftedFilterArr.filter(filterFunc);
          setSearchResults(filteredSearchArr);
        } else {
          setSearchResults(draftedFilterArr);
        }
        handlePageChange(1);
      }
    }, 500);

    return () => setTypingTimeout(timeout);
  }, [search, currentFilters, fetchingPrograms]);

  useEffect(() => {
    if (searchResults) {
      const start = currentPage * 10 - 10;
      const end = currentPage * 10;
      const rangeData = searchResults.slice(start, end);
      setCurrentData(rangeData);
    }
  }, [currentPage, searchResults]);

  useEffect(() => {
    if (programCreated) {
      setShowModal(false);
      getAllPrograms({
        workspaceId: selectedWorkspace.workspace_id,
        flowType: currentFlow,
      });
      getAllGroups({
        workspaceId: selectedWorkspace.workspace_id,
        flowType: currentFlow,
      });
    }
  }, [programCreated]);

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const refreshPage = () => {
    getAllPrograms({
      workspaceId: selectedWorkspace.workspace_id,
      flowType: currentFlow,
    });
  };

  const handleSelect = val => {
    const newCurrentFilters = [...currentFilters];
    if (includesOption(newCurrentFilters, val)) {
      const index = indexOfOption(newCurrentFilters, val);
      newCurrentFilters.splice(index, 1);
    } else {
      newCurrentFilters.push(val);
    }
    setCurrentFilters(newCurrentFilters);
  };
  const clearFilters = () => {
    setCurrentFilters([]);
  };
  const handleSort = (column, sortDirection) => {
    setSearchResults(orderBy(searchResults, column.selector, sortDirection));
  };
  const exportSearchResultCSV = () => {
    const headColumns = [
      { key: 'name', value: 'Meal Plan Name' },
      { key: 'cycle_type', value: 'Frequency' },
      { key: 'budget', value: 'Budget/employee' },
      { key: 'employees', value: 'No. of employees' },
      { key: 'program_status', value: 'Status' },
    ];
    const statusLabelledData = [];
    searchResults.forEach(data => {
      const labelledData = {};
      labelledData.name = data.name;
      labelledData.cycle_type = frequencyTypes[data.cycle_type];
      labelledData.budget = getCycleAmountForCSV(data);
      labelledData.employees = getEmployeesCountFromGroups(data.groups_data);
      labelledData.program_status =
        statusLabels[programStatusEnum[data.program_status]];
      statusLabelledData.push(labelledData);
    });
    exportCSV(
      statusLabelledData,
      `Meal Plans - ${getCurrentDate()}`,
      headColumns,
    );
  };
  const downloadCSVStyle = {
    padding: '15px 20px 10px 0px',
    cursor: 'pointer',
  };

  const renderCreateMealPlanBtn = () => (
    <div>
      <Button
        icon={<Plus />}
        iconAlign='left'
        onClick={() => navigate(CREATE_PLAN_ROUTE)}
        disabled={viewOnlyMode}
      >
        Create meal plan
      </Button>
    </div>
  );

  if (fetchingPrograms) {
    return (
      <DashboardWrapper>
        <SpinnerHolder className='center'>
          <Spinner color={red.z_red} size='medium' />
        </SpinnerHolder>
      </DashboardWrapper>
    );
  }
  if (!fetchedPrograms) {
    return (
      <DashboardWrapper>
        <ErrorPage
          showAction
          actionLabel={REFRESH_LABEL}
          clickAction={refreshPage}
        />
      </DashboardWrapper>
    );
  }

  return isEmptyPrograms ? (
    <>
      {showModal && (
        <CreateProgramModal
          title={MEAL_PLAN}
          showModal={showModal}
          closeModal={closeModal}
          modalClose={modalClose}
        />
      )}
      <EmptyStateV2
        state={PROGRAMS}
        title={emptyProgramStateTitle}
        actionComponent={renderCreateMealPlanBtn}
      />
    </>
  ) : (
    <DashboardWrapper>
      {showModal && (
        <CreateProgramModal
          title={MEAL_PLAN}
          showModal={showModal}
          closeModal={closeModal}
          modalClose={modalClose}
        />
      )}
      {viewOnlyMode && <Banner />}
      {!isFullFlexEnabled && (
        <AnnouncementBanner
          title='Coming Soon'
          subtitle='Get smarter insights with a refreshed Meal Plans dashboard, arriving by March 2026.'
        />
      )}
      <BreadCrumbWrapper>
        <Breadcrumb>
          <Breadcrumb.Link
            style={{ color: 'var(--coolgreycoolgrey-400, #AFB4C0)' }}
            linkTo={`${DASHBOARD_ROUTE}#${HOME_ROUTE}`}
          >
            Home
          </Breadcrumb.Link>
          <Breadcrumb.Link
            style={{ color: 'var(--coolgreycoolgrey-800, #414A5D)' }}
          >
            Meal Plans
          </Breadcrumb.Link>
        </Breadcrumb>
      </BreadCrumbWrapper>
      <TabHeadWrapper>
        <H5>Meal Plans</H5>
        {renderCreateMealPlanBtn()}
      </TabHeadWrapper>
      <TabWrapper>
        <SearchContainerV2>
          <SearchInput
            leftIcon={<Search />}
            innerWidth='100%'
            value={search}
            onChange={onInputChange}
            onFocus={() => setIsSearchClicked(true)}
            onBlur={() => setIsSearchClicked(false)}
            label={
              isSearchClicked || disabledSearch || search?.length ? (
                'Search by name'
              ) : (
                <span style={{ fontSize: '16px', fontWeight: 300 }}>
                  {' '}
                  Search by meal plan name
                  {' '}
                </span>
              )
            }
            disabled={disabledSearch}
          />
          <StatusFilterAndExportCSVContainer>
            <StatusFilter
              isDisabled={disabledSearch}
              clearFilters={clearFilters}
              currentFilters={currentFilters}
              options={filterStatusOptions}
              handleSelect={handleSelect}
            />
            {disabledSearch ? (
              <Download
                color='grey'
                style={{ padding: '10px 20px 20px 0px' }}
              />
            ) : (
              <Tooltip
                position='top'
                label='Download the meal plan list'
                appearance='light'
                size='big'
                style={{
                  fontSize: '12px',
                  opacity: 0.8,
                  marginRight: '10px',
                  marginLeft: '-30px',
                  padding: '10px',
                }}
              >
                <Download
                  color='grey'
                  onClick={exportSearchResultCSV}
                  style={downloadCSVStyle}
                />
              </Tooltip>
            )}
          </StatusFilterAndExportCSVContainer>
        </SearchContainerV2>
        <TableContainer>
          {!fetchedPrograms ? (
            <ErrorPage
              showAction
              actionLabel={REFRESH_LABEL}
              clickAction={refreshPage}
            />
          ) : (
            <DataTables
              columns={
                currentFlow === currentFlowTypeEnum.FLOW_TYPE_LIMIT
                  ? (() =>
                      isFullFlexEnabled
                        ? fullFlexProgramHeadColumn
                        : limitProgramsHeadColumn)()
                  : programHeadColumn
              }
              loading={fetchingPrograms || loading}
              data={currentData}
              pagination
              totalRows={searchResults.length}
              handlePageChange={handlePageChange}
              onSort={handleSort}
              emptyStateTitle='No meal plans'
            />
          )}
        </TableContainer>
      </TabWrapper>
    </DashboardWrapper>
  );
};

WalletPrograms.propTypes = {
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  companyData: PropTypes.objectOf(PropTypes.any),
  fetchedPrograms: PropTypes.bool,
  fetchingPrograms: PropTypes.bool,
  programsData: PropTypes.objectOf(PropTypes.any),
  getAllPrograms: PropTypes.func,
  getAllGroups: PropTypes.func,
  getAllQuestions: PropTypes.func,
  programCreated: PropTypes.bool,
  viewOnlyMode: PropTypes.bool,
};

WalletPrograms.defaultProps = {
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
  fetchedPrograms: true,
  fetchingPrograms: true,
  programsData: {},
  programCreated: false,
  getAllPrograms: _noop,
  getAllGroups: _noop,
  getAllQuestions: _noop,
  selectedWorkspace: {},
  companyData: {},
  viewOnlyMode: false,
};

export default WalletPrograms;
